<script lang="ts">
	import type { BoutInfo } from '../types';
	import FighterAttributesComparison from './FighterAttributesComparison.svelte';
	import FighterStats from './FighterStats.svelte';
	import { fetchBoutStats } from '../api/xapi/fetch';
	import moment from 'moment';

	export let bout: BoutInfo;

	let stats = bout.statistic;

	let lastRefreshedAt: Date | null = null;
	let isFetchingStats = false;

	function fetchStats(liveID?: number, finalID?: number) {
		isFetchingStats = true;

		const fetchingLive = liveID ? fetchBoutStats(liveID) : null;
		const fetchingFinal = finalID ? fetchBoutStats(finalID) : null;

		Promise.all([fetchingLive, fetchingFinal]).then(([live, final]) => {
			if (live) {
				bout.liveStats = live;
			}
			if (final) {
				bout.finalStats = final;
			}
			isFetchingStats = false;
		});
	}

	function handleRefreshClick() {
		fetchStats(stats.liveId, stats.finalId);
	}

	$: fetchStats(stats.liveId, stats.finalId);
</script>

<div class="row">
	<div class="col-12 fmatch">
		{#if bout}
			<FighterAttributesComparison
				blue={bout.attributes.blueCorner}
				red={bout.attributes.redCorner}
			/>

			<div class="d-flex mb-3">
				<div class="empty-sidebar d-none d-sm-block" />
				<ul class="nav nav-pills">
					<li class="nav-item">
						<a
							class="nav-link active"
							aria-current="page"
							data-bs-toggle="pill"
							data-bs-target="#live">Live Stats</a
						>
					</li>
					<li class="nav-item">
						<a class="nav-link" data-bs-toggle="pill" data-bs-target="#final">Final Stats</a>
					</li>
				</ul>
				<section class="ms-auto refresh-block">
					{#if lastRefreshedAt && !isFetchingStats}
						<span class="d-none d-sm-inline me-1"
							>Last refreshed {moment(lastRefreshedAt).fromNow()}</span
						>
					{/if}
					<button
						class="btn btn-outline-danger ms-auto"
						on:click={handleRefreshClick}
						disabled={isFetchingStats}
					>
						{#if isFetchingStats}
							<span
								class="spinner-border-sm spinner-border text-danger me-1"
								role="status"
								aria-hidden="true"
							/>
						{/if}
						Refresh
					</button>
				</section>
			</div>

			<div class="tab-content">
				<div class="tab-pane show active" id="live" role="tabpanel">
					<FighterStats stats={bout.liveStats} statsType="live" />
				</div>
				<div class="tab-pane" id="final" role="tabpanel">
					{#if stats.finalId}
						<FighterStats stats={bout.finalStats} statsType="final" />
					{:else}
						<p class="text-center mt-3">Final stats are not available yet</p>
					{/if}
				</div>
			</div>
		{/if}
	</div>
</div>

<style>
	.fmatch {
		padding: 5% 1%;
	}

	.nav-pills .nav-link {
		color: rgb(73, 73, 73);
		cursor: pointer;
	}

	.nav-pills .nav-link.active {
		background-color: #adb5bd;
		color: white;
	}

	.refresh-block span {
		padding-right: 5px;
		font-size: 12px;
	}
</style>
